import React, { useEffect, useState, createContext, useContext } from 'react';
type Language = 'es' | 'en';
interface Translations {
  [key: string]: {
    es: string;
    en: string;
  };
}
const translations: Translations = {
  // Navigation
  'nav.home': {
    es: 'Inicio',
    en: 'Home'
  },
  'nav.gallery': {
    es: 'Galería',
    en: 'Gallery'
  },
  // Hero
  'hero.badge': {
    es: 'Modelo Profesional',
    en: 'Professional Model'
  },
  'hero.title1': {
    es: 'El Arte de la',
    en: 'The Art of'
  },
  'hero.title2': {
    es: 'Elegancia',
    en: 'Elegance'
  },
  'hero.subtitle': {
    es: 'Descubre mi trayectoria en el mundo del modelaje, el proceso creativo detrás de cada sesión y únete a una comunidad que valora el arte y la sofisticación.',
    en: 'Discover my journey in the modeling world, the creative process behind each session, and join a community that values art and sophistication.'
  },
  'hero.cta': {
    es: 'Explorar Mi Trabajo',
    en: 'Explore My Work'
  },
  'hero.followers': {
    es: 'Seguidores',
    en: 'Followers'
  },
  'hero.professional': {
    es: 'Profesional',
    en: 'Professional'
  },
  // Bio
  'bio.label': {
    es: 'Mi Trayectoria',
    en: 'My Journey'
  },
  'bio.description1': {
    es: 'Mi carrera como modelo profesional es el resultado de años de dedicación, evolución constante y pasión por el arte visual. Cada proyecto es una oportunidad para explorar nuevas facetas creativas.',
    en: 'My career as a professional model is the result of years of dedication, constant evolution, and passion for visual art. Each project is an opportunity to explore new creative facets.'
  },
  'bio.description2': {
    es: 'Con más de 3 millones de seguidores, he tenido el privilegio de colaborar con marcas internacionales y participar en producciones editoriales que desafían los límites de la creatividad.',
    en: 'With over 3 million followers, I have had the privilege of collaborating with international brands and participating in editorial productions that push the boundaries of creativity.'
  },
  'bio.feature1.title': {
    es: 'Producciones Editoriales',
    en: 'Editorial Productions'
  },
  'bio.feature1.desc': {
    es: 'Sesiones de alta moda y campañas internacionales',
    en: 'High fashion sessions and international campaigns'
  },
  'bio.feature2.title': {
    es: 'Proceso Creativo',
    en: 'Creative Process'
  },
  'bio.feature2.desc': {
    es: 'El making of y la visión detrás de cada proyecto',
    en: 'The making of and vision behind each project'
  },
  'bio.feature3.title': {
    es: 'Evolución Profesional',
    en: 'Professional Evolution'
  },
  'bio.feature3.desc': {
    es: 'Mi trayectoria y crecimiento en la industria',
    en: 'My journey and growth in the industry'
  },
  'bio.cta': {
    es: 'Explorar Portfolio',
    en: 'Explore Portfolio'
  },
  // Gallery
  'gallery.label': {
    es: 'Portfolio Seleccionado',
    en: 'Selected Portfolio'
  },
  'gallery.title': {
    es: 'Trabajos Destacados',
    en: 'Featured Work'
  },
  'gallery.subtitle': {
    es: 'Una selección curada de mis producciones editoriales y campañas de alta moda',
    en: 'A curated selection of my editorial productions and high fashion campaigns'
  },
  'gallery.cta': {
    es: 'Acceder al Portfolio Completo',
    en: 'Access Full Portfolio'
  },
  'gallery.ctaSubtext': {
    es: 'Explora mi trayectoria profesional y trabajos editoriales',
    en: 'Explore my professional journey and editorial work'
  },
  'gallery.category1': {
    es: 'Alta Moda',
    en: 'High Fashion'
  },
  'gallery.category2': {
    es: 'Editorial',
    en: 'Editorial'
  },
  // Exclusive
  'exclusive.badge': {
    es: 'Acceso Completo',
    en: 'Full Access'
  },
  'exclusive.title1': {
    es: 'Mi Comunidad',
    en: 'My Creative'
  },
  'exclusive.title2': {
    es: 'Creativa',
    en: 'Community'
  },
  'exclusive.subtitle': {
    es: 'Un espacio dedicado para quienes valoran el proceso creativo, la evolución profesional y el arte del modelaje',
    en: 'A dedicated space for those who value the creative process, professional evolution, and the art of modeling'
  },
  'exclusive.benefit1.title': {
    es: 'Archivo Profesional',
    en: 'Professional Archive'
  },
  'exclusive.benefit1.desc': {
    es: 'Acceso completo a mi portfolio de trabajos editoriales y campañas internacionales',
    en: 'Full access to my portfolio of editorial work and international campaigns'
  },
  'exclusive.benefit2.title': {
    es: 'Proceso Creativo',
    en: 'Creative Process'
  },
  'exclusive.benefit2.desc': {
    es: 'El making of de mis producciones y la visión detrás de cada proyecto',
    en: 'The making of my productions and the vision behind each project'
  },
  'exclusive.benefit3.title': {
    es: 'Trayectoria & Evolución',
    en: 'Journey & Evolution'
  },
  'exclusive.benefit3.desc': {
    es: 'Mi recorrido profesional, colaboraciones y momentos destacados de mi carrera',
    en: 'My professional journey, collaborations, and career highlights'
  },
  'exclusive.benefit4.title': {
    es: 'Comunidad Creativa',
    en: 'Creative Community'
  },
  'exclusive.benefit4.desc': {
    es: 'Únete a una comunidad que aprecia el arte, la moda y la creatividad profesional',
    en: 'Join a community that appreciates art, fashion, and professional creativity'
  },
  'exclusive.cta': {
    es: 'Unirme a la Comunidad',
    en: 'Join the Community'
  },
  'exclusive.ctaSubtext': {
    es: 'Únete a una comunidad que valora la creatividad y el profesionalismo',
    en: 'Join a community that values creativity and professionalism'
  },
  // Social
  'social.label': {
    es: 'Sígueme en Redes Sociales',
    en: 'Follow Me on Social Media'
  },
  // Footer
  'footer.rights': {
    es: 'Todos los derechos reservados.',
    en: 'All rights reserved.'
  },
  'footer.terms': {
    es: 'Términos de Servicio',
    en: 'Terms of Service'
  },
  'footer.privacy': {
    es: 'Política de Privacidad',
    en: 'Privacy Policy'
  },
  'footer.age': {
    es: 'Este sitio está destinado exclusivamente para mayores de 18 años.',
    en: 'This site is intended exclusively for people over 18 years old.'
  }
};
interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string) => string;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [language, setLanguage] = useState<Language>('es');
  // Detect browser language on mount
  useEffect(() => {
    const browserLang = navigator.language.toLowerCase();
    if (browserLang.startsWith('en')) {
      setLanguage('en');
    } else {
      setLanguage('es');
    }
  }, []);
  const t = (key: string): string => {
    const translation = translations[key];
    if (!translation) {
      console.warn(`Translation missing for key: ${key}`);
      return key;
    }
    return translation[language];
  };
  return <LanguageContext.Provider value={{
    language,
    setLanguage,
    t
  }} data-id="element-341">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}